import { query } from '@angular/animations';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, HttpUrlGenerator, QueryParams } from '@ngrx/data';
import { Observable, of, switchMap } from 'rxjs';
import { HelperService } from 'src/app/service/helper.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';
import { County } from '../../../model/county';
import { Region } from '../../../model/region.model';

@Injectable({
    providedIn: 'root'
})
export class CountyDataService extends DefaultDataService<County> {
    constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, public urlProvider: UrlProviderService, private helperService: HelperService) {
        super('County', http, httpUrlGenerator);
    }

    override getAll(): Observable<County[]> {
        const url = this.urlProvider.getUrl(EndPoints.county, undefined, undefined);
        let lstRegion: Region[] = [];
        this.helperService.lstRegion$.subscribe((x) => {
            lstRegion = x;
        });
        return this.http
            .post(
                url,
                { regions: lstRegion },
                (Headers = {
                    ...this.urlProvider.baseGetOptions()
                })
            )
            .pipe(
                switchMap((res: any) => {
                    return of(<County[]>JSON.parse(res.body['counties']));
                })
            );
    }
}
